// Partner directory for I DO Bridal Magazine Malta
// Extracted from PartnersPage.jsx for maintainability.

export const slugifyPartner = (name) =>
  name
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/&/g, 'and')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

export const getPartnerSlug = (partner) => partner.slug || slugifyPartner(partner.name);

export const getPartnerBySlug = (slug) => partners.find((p) => getPartnerSlug(p) === slug);

export const partnerCategories = [
  'All', 'Venues', 'Photography', 'Catering', 'Fashion', 'Beauty',
  'Floristry', 'Entertainment', 'Transport', 'Décor',
  'Home & Lifestyle', 'Services',
];

export const partners = [
  // Featured Partners (from Winter 2025 issue)
  {
    id: 2,
    name: 'Elia Caterers',
    category: 'Catering',
    description: 'Premium catering services with a passion for Mediterranean cuisine, creating unforgettable culinary experiences for weddings.',
    location: 'Various Locations, Malta',
    image: 'https://images.unsplash.com/photo-1555244162-803834f70033?w=600&h=400&fit=crop',
    website: 'https://elia.com.mt/',
    instagram: 'https://www.instagram.com/eliacaterers/',
    featured: false,
  },
  {
    id: 3,
    name: 'Siemenjov Galdes Weddings',
    category: 'Photography',
    description: 'Award-winning documentary wedding photographer and film team based in Pembroke, Malta. Real moments, captured with truth: photography, cinematic film, fine art printing, custom albums and photo booths for weddings across Malta and Gozo.',
    story: "Hey, I'm Siemenjov, a documentary wedding photographer based in Malta with more than a decade of experience. In 2019 I chose the path to become a full-time wedding photographer; it is my life's passion and I love every single second of it. Couples who work with me want a unique, natural narrative capturing what is most important on the day. My style blends lifestyle and classic with a love for details, and over the past few years I have built a team of ten trusted photography and film professionals who are simply the best at what they do. With a calm, unobtrusive approach, we let your day unfold naturally and focus on the in-between moments: the quiet gestures, the bursts of laughter, and the true connection that makes your story unique.",
    services: [
      'Modern and documentary-style wedding photography',
      'Elegant, natural cinematic wedding films',
      'Fine art printing and custom wedding albums',
      'Modern photo booth experience for your guests',
      'Pre-wedding shoots and free consultation at the Pembroke studio',
    ],
    testimonial: {
      quote: "We couldn't have asked for a better photographer and team for our wedding day. He made us feel completely at ease, like old friends who genuinely cared about capturing our day in the most natural and beautiful way possible.",
      author: 'Jessica & Kyle, October 2024',
    },
    location: 'Pembroke, Malta & Gozo',
    address: '12, Triq Mikiel Ang Grima, Pembroke',
    phone: '+356 9982 0890',
    email: 'hello@siemenjovgaldes.com',
    image: '/images/vendors/siemenjov/sg-3.jpg',
    portrait: '/images/vendors/siemenjov/sg-11.jpg',
    gallery: [
      '/images/vendors/siemenjov/sg-3.jpg',
      '/images/vendors/siemenjov/sg-7.jpg',
      '/images/vendors/siemenjov/sg-8.jpg',
      '/images/vendors/siemenjov/sg-2.jpg',
      '/images/vendors/siemenjov/sg-4.jpg',
      '/images/vendors/siemenjov/sg-9.jpg',
      '/images/vendors/siemenjov/sg-10.jpg',
      '/images/vendors/siemenjov/sg-1.jpg',
      '/images/vendors/siemenjov/sg-6.jpg',
      '/images/vendors/siemenjov/sg-5.jpg',
    ],
    website: 'https://www.siemenjovgaldes.com',
    instagram: 'https://www.instagram.com/siemenjov_galdes_weddings/',
    featured: true,
  },
  {
    id: 4,
    name: 'Alamango',
    category: 'Fashion',
    description: 'Exquisite bridal fashion boutique offering designer gowns and bespoke creations for the modern bride.',
    location: 'Sliema, Malta',
    image: 'https://images.unsplash.com/photo-1766149481900-328c59e7f17a?w=600&h=400&fit=crop',
    website: 'https://www.alamango.com.mt',
    instagram: 'https://www.instagram.com/alamango_fashion/',
    featured: true,
  },
  {
    id: 5,
    name: 'Flowers by Nanette',
    category: 'Floristry',
    description: 'Artisanal floral design creating romantic, elegant arrangements that bring your wedding vision to life.',
    location: 'Birkirkara, Malta',
    image: 'https://images.unsplash.com/photo-1487530811176-3780de880c2d?w=600&h=400&fit=crop',
    website: 'https://www.facebook.com/nanettefloraldesign/',
    instagram: 'https://www.instagram.com/nanette.floraldesigner/',
    featured: true,
  },
  // Other partners from Winter 2025 issue
  {
    id: 6,
    name: 'Glam by Gracelyn',
    category: 'Beauty',
    description: 'Professional bridal makeup artistry creating flawless, camera-ready looks that last all day.',
    location: 'Malta',
    image: 'https://images.unsplash.com/photo-1487412947147-5cebf100ffc2?w=600&h=400&fit=crop',
    website: 'https://www.facebook.com/glambygracelyn/',
    instagram: 'https://www.instagram.com/glambygracelyn/',
    featured: false,
  },
  {
    id: 7,
    name: 'Silver Scissors',
    category: 'Beauty',
    description: 'Expert hair styling services specializing in bridal and special occasion looks.',
    location: 'Malta',
    image: 'https://images.unsplash.com/photo-1560066984-138dadb4c035?w=600&h=400&fit=crop',
    website: 'https://www.facebook.com/silver.scissors.75',
    instagram: '#',
    featured: false,
  },
  {
    id: 8,
    name: 'Bortex Fine Tailoring',
    category: 'Fashion',
    description: 'Premium menswear and tailoring services for grooms seeking sophistication and style.',
    location: 'Valletta, Malta',
    image: 'https://images.unsplash.com/photo-1507679799987-c73779587ccf?w=600&h=400&fit=crop',
    website: 'https://bortex.com.mt',
    instagram: 'https://www.instagram.com/bortexfinetailoring/',
    featured: true,
  },
  {
    id: 9,
    name: 'Clement Jewellers',
    category: 'Fashion',
    description: 'Fine jewellery specialists offering exquisite wedding bands and engagement rings.',
    location: 'Birkirkara, Malta',
    image: 'https://images.unsplash.com/photo-1736154577794-65871df026ea?w=600&h=400&fit=crop',
    website: 'https://clementjewellers.com',
    instagram: 'https://www.instagram.com/clement_jewellers/',
    featured: true,
  },
  {
    id: 10,
    name: "Damian's Cocktails",
    category: 'Catering',
    description: 'Premium mobile bar services creating bespoke cocktail experiences for your wedding reception.',
    location: 'Malta',
    image: 'https://images.unsplash.com/photo-1551024709-8f23befc6f87?w=600&h=400&fit=crop',
    website: 'https://www.damianscocktailsmalta.com',
    instagram: 'https://www.instagram.com/damiancocktails/',
    featured: true,
  },
  {
    id: 11,
    name: 'Elite Transport Malta',
    category: 'Transport',
    description: 'Classic wedding car hire, beautifully restored vintage and classic vehicles bringing timeless elegance to your big day.',
    location: 'Malta',
    image: '/images/vendors/elite-vintage-car.jpg',
    website: 'https://www.elitetransportmt.com/wedding-cars',
    instagram: 'https://www.instagram.com/elitetransportmt/',
    featured: true,
  },
  {
    id: 12,
    name: 'Cleland & Souchet',
    category: 'Décor',
    description: 'Creative wedding styling and décor specialists transforming venues into dreamscapes.',
    location: 'Malta',
    image: 'https://images.unsplash.com/photo-1478146896981-b80fe463b330?w=600&h=400&fit=crop',
    website: 'https://www.clelandsouchet.com',
    instagram: 'https://www.instagram.com/cleland_souchet/',
    featured: false,
  },
  {
    id: 13,
    name: 'Booth! Malta',
    category: 'Entertainment',
    description: 'Fun and interactive photo booth services creating memorable moments at your reception.',
    location: 'Malta',
    image: 'https://static.prod-images.emergentagent.com/jobs/4d821d9a-f1d9-4d63-ae58-b7c29b0e73b7/images/6df5dff206f588600b22fa29b03e1363ffb7a0fd8ced042c10f95796046328c6.png',
    website: 'https://boothmalta.com',
    instagram: 'https://www.instagram.com/booth_malta/',
    featured: true,
  },
  {
    id: 14,
    name: 'Monsoon Malta',
    category: 'Fashion',
    description: "Beautiful flower girl dresses and page boy outfits, children's occasion wear designed to make the little ones in your bridal party look just as enchanting as the bride.",
    location: 'Sliema, Malta',
    image: 'https://customer-assets.emergentagent.com/job_fdaaf3ca-6030-4a2e-8a59-67f6d31ca384/artifacts/v4hjdz47_51_51400280170_6-350x435.webp',
    website: 'https://www.facebook.com/MonsoonChildrenMalta',
    instagram: 'https://www.instagram.com/monsoonmalta/',
    featured: true,
  },
  {
    id: 16,
    name: 'Vanity Lounge',
    category: 'Beauty',
    description: 'Full-service beauty salon offering bridal packages for hair, makeup, and nails.',
    location: 'Malta',
    image: 'https://images.unsplash.com/photo-1560066984-138dadb4c035?w=600&h=400&fit=crop',
    website: '#',
    instagram: 'https://www.instagram.com/vanitylounge.malta/',
    featured: true,
  },
  // New partners from CRM
  {
    id: 18,
    name: 'Mediterranean Conference Centre',
    category: 'Venues',
    description: 'Historic venue in the heart of Valletta, perfect for grand celebrations.',
    location: 'Valletta, Malta',
    image: 'https://images.unsplash.com/photo-1519167758481-83f550bb49b3?w=600&h=400&fit=crop',
    website: 'https://mcc.com.mt/',
    instagram: '#',
    featured: false,
  },
  {
    id: 19,
    name: 'Oxford House',
    category: 'Services',
    description: 'Quality home appliances and homeware for your new life together.',
    location: 'Malta',
    image: 'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=600&h=400&fit=crop',
    website: 'https://oxfordhouse.com.mt/',
    instagram: '#',
    featured: false,
  },
  {
    id: 20,
    name: 'Country Terrace Gozo',
    category: 'Venues',
    description: 'Charming countryside restaurant and venue with stunning Gozo views.',
    location: 'Gozo, Malta',
    image: 'https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?w=600&h=400&fit=crop',
    website: 'https://www.country-terrace.com/',
    instagram: '#',
    featured: false,
  },
  {
    id: 22,
    name: 'Malta Marriott Resort & Spa',
    category: 'Venues',
    description: 'Luxury hotel and spa offering elegant wedding venues by the sea.',
    location: "St. Julian's, Malta",
    image: 'https://images.unsplash.com/photo-1566073771259-6a8506099945?w=600&h=400&fit=crop',
    website: 'https://www.marriott.com/en-us/hotels/mlamc-malta-marriott-resort-and-spa/overview/',
    instagram: '#',
    featured: false,
  },
  {
    id: 24,
    name: 'Tiziana Dance Studio',
    category: 'Entertainment',
    description: 'Professional dance lessons for your first dance and wedding entertainment.',
    location: 'Malta',
    image: 'https://images.unsplash.com/photo-1504609773096-104ff2c73ba4?w=600&h=400&fit=crop',
    website: 'https://www.facebook.com/TizianaDanceStudio/',
    instagram: '#',
    featured: false,
  },
  {
    id: 25,
    name: 'BG Malta Fireworks',
    category: 'Entertainment',
    description: 'Spectacular fireworks displays to celebrate your special day.',
    location: 'Malta',
    image: 'https://customer-assets.emergentagent.com/job_fdaaf3ca-6030-4a2e-8a59-67f6d31ca384/artifacts/6afcysei_486850501_1192187736245598_7843617033295250835_n.jpg',
    website: 'https://www.facebook.com/bgmaltafireworksdisplay/',
    instagram: '#',
    featured: false,
  },
  {
    id: 27,
    name: 'Villa Bighi',
    category: 'Venues',
    description: 'Historic waterfront venue overlooking the Grand Harbour with panoramic views and timeless Maltese character.',
    location: 'Grand Harbour, Kalkara, Malta',
    image: 'https://images.unsplash.com/photo-1519167758481-83f550bb49b3?w=600&h=400&fit=crop',
    website: '#',
    instagram: '#',
    featured: false,
  },
  {
    id: 29,
    name: 'Hilton Malta',
    category: 'Venues',
    description: 'Luxury five-star hotel and spa offering elegant wedding venues with stunning Mediterranean views and world-class service.',
    location: "St. Julian's, Malta",
    image: 'https://images.unsplash.com/photo-1595360323074-1f06be35aa33?w=600&h=400&fit=crop',
    website: 'https://www.hilton.com/en/hotels/mlahitw-hilton-malta/',
    instagram: '#',
    featured: true,
  },
  {
    id: 30,
    name: 'Villa Blanche by JC Events',
    category: 'Venues',
    description: 'An elegant and versatile wedding venue managed by JC Events, perfect for unforgettable celebrations.',
    location: 'Malta',
    image: 'https://images.unsplash.com/photo-1763505811842-ec77de71355a?w=600&h=400&fit=crop',
    website: 'https://jcevents.com.mt/events/',
    instagram: '#',
    featured: false,
  },
  {
    id: 31,
    name: 'Isle Décor',
    category: 'Décor',
    description: 'Premium wedding styling and décor services creating unforgettable event settings.',
    location: 'Malta',
    image: 'https://images.unsplash.com/photo-1763553113391-a659bee36e06?w=600&h=400&fit=crop',
    website: 'https://www.isle-decor.com/',
    instagram: '#',
    featured: false,
  },
  {
    id: 32,
    name: 'Villa Arrigo',
    category: 'Venues',
    description: 'Stunning 17th-century palazzo and gardens offering a timeless backdrop for elegant weddings.',
    location: 'Naxxar, Malta',
    image: 'https://images.unsplash.com/photo-1763505811842-ec77de71355a?w=600&h=400&fit=crop',
    website: '#',
    instagram: '#',
    featured: false,
  },
  {
    id: 33,
    name: 'Troopers Wedding Events',
    category: 'Entertainment',
    description: 'Creative wedding event entertainment and production specialists bringing energy and excitement to your celebration.',
    location: 'Malta',
    image: 'https://images.unsplash.com/photo-1764380745709-0f427f6d26b2?w=600&h=400&fit=crop',
    website: '#',
    instagram: '#',
    featured: false,
  },
  {
    id: 34,
    name: 'Xara Catering',
    category: 'Catering',
    description: 'Premium catering services delivering exquisite menus and impeccable service for weddings of all sizes.',
    location: 'Malta',
    image: 'https://images.unsplash.com/photo-1773314863076-835e0bdbe3ea?w=600&h=400&fit=crop',
    website: '#',
    instagram: '#',
    featured: false,
  },
  {
    id: 35,
    name: 'Mattress Collection',
    category: 'Services',
    description: 'Premium mattresses and bedroom furnishings for newlyweds starting their new life together.',
    location: 'Malta',
    image: 'https://images.unsplash.com/photo-1672122816795-49ff5cbc75e8?w=600&h=400&fit=crop',
    website: '#',
    instagram: '#',
    featured: false,
  },
  {
    id: 36,
    name: 'Vintage Bus',
    category: 'Transport',
    description: 'Iconic vintage buses adding a unique and charming touch to your wedding day transport.',
    location: 'Malta',
    image: 'https://images.unsplash.com/photo-1755811096452-6e7d4783191b?w=600&h=400&fit=crop',
    website: '#',
    instagram: '#',
    featured: false,
  },
  {
    id: 37,
    name: 'Makeup by Michaela',
    category: 'Beauty',
    description: 'Bridal makeup artistry by Michaela Buttigieg, flawless, luminous looks tailored to every bride, designed to last from "I do" through the dance floor.',
    location: 'Malta',
    image: 'https://images.unsplash.com/photo-1503236823255-94609f598e71?w=600&h=400&fit=crop',
    website: 'https://www.facebook.com/p/Michaela-Buttigieg-The-Makeup-Artist-100094268821226/',
    instagram: '#',
    featured: true,
  },
  {
    id: 38,
    name: 'So Ellie',
    category: 'Fashion',
    description: 'A curated boutique of bridal accessories, jewellery and stylish pieces for the modern Maltese bride and her bridal party.',
    location: 'Malta',
    image: 'https://images.unsplash.com/photo-1535632787350-4e68ef0ac584?w=600&h=400&fit=crop',
    website: 'https://by-elly.myshopify.com/',
    instagram: '#',
    featured: true,
  },
  // New additions (Spring/Summer 2026)
  {
    id: 40,
    name: 'VALÀ Home & Contract',
    category: 'Home & Lifestyle',
    description: 'Malta-based design and furnishing house offering premium furniture, lighting and interior solutions. A favourite for styled shoots, venue dressing and luxury wedding editorials.',
    location: 'Malta',
    image: 'https://images.unsplash.com/photo-1616627547584-bf28cee262db?w=600&h=400&fit=crop',
    website: '#',
    instagram: '#',
    featured: false,
  },
  {
    id: 41,
    name: 'JB Stores',
    category: 'Home & Lifestyle',
    description: "One of Malta's most recognisable lifestyle retailers, offering homeware, furniture, décor and kitchenware. A trusted partner for bridal registries and newlywed home features.",
    location: 'Malta',
    image: 'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=600&h=400&fit=crop',
    website: '#',
    instagram: '#',
    featured: false,
  },
  {
    id: 42,
    name: 'Corinthia Caterers',
    category: 'Catering',
    description: "One of Malta's leading catering and event service providers, delivering bespoke menus, high-end dining and professional event management for luxury weddings and celebrations.",
    location: 'Malta',
    image: 'https://images.unsplash.com/photo-1530541930197-ff16ac917b0e?w=600&h=400&fit=crop',
    website: 'https://www.corinthiacaterers.com/',
    instagram: '#',
    featured: false,
  },
  {
    id: 44,
    name: 'The Khinos',
    category: 'Entertainment',
    description: 'Malta-based live band delivering polished performances for weddings and private events, featured in our Spring & Summer 2026 Candyland Romance editorial.',
    location: 'Malta',
    image: 'https://customer-assets.emergentagent.com/job_ba5a83e9-a81b-438c-bcb8-bdf67a8056f4/artifacts/3dr4j3ks_20260422_SUMMER--2026_292.jpg',
    website: '#',
    instagram: '#',
    featured: true,
  },
  {
    id: 45,
    name: 'Styled by Paige',
    category: 'Beauty',
    description: 'UK and Malta trained hairdresser specialising in bridal and occasion hair and extensions. One-to-one appointments, trials always available, and Paige travels across Malta on the big day. Bridal styling from €120.',
    location: 'Mobile across Malta',
    image: '/images/vendors/styled-by-paige.jpg',
    website: 'https://styledbypaige.eu/',
    instagram: 'https://instagram.com/styled_by_paige_',
    featured: false,
  },
  {
    id: 46,
    name: 'Port Gillieru',
    category: 'Venues',
    description: 'Set on the shores of St Paul\'s Bay within the historic Gillieru complex, a beloved Maltese seaside landmark. Breathtaking sea views and flexible indoor and outdoor spaces for weddings of any size, with every detail handled by the Bastions View Group team.',
    location: 'St Paul\'s Bay, Malta',
    image: '/images/vendors/port-gillieru-terrace.jpg',
    website: 'https://portgillieru.mt',
    instagram: 'https://www.instagram.com/portgillieru/',
    featured: false,
  },
];
